import { createAction, props } from '@ngrx/store';

export const generatePublicLink = createAction(
  '[SharedLink] Generate Public Link',
  props<{ projectUUID: string }>()
);

export const generatePublicLinkSuccess = createAction(
  '[SharedLink] Generate Public Link Success',
  props<{ token: string }>()
);

export const generatePublicLinkFailure = createAction(
  '[SharedLink] Generate Public Link Failure',
  props<{ error: any }>()
);


export const validateToken = createAction(
  '[SharedLink] Validate Token',
  props<{ token: string, projectUUID: string }>()
);

export const validateTokenSuccess = createAction(
  '[SharedLink] Validate Token Success',
  props<{ is_validated: boolean, msg: string }>()
);

export const validateTokenFailure = createAction(
  '[SharedLink] Validate Token Failure',
  props<{ error: any }>()
);
export const getToken = createAction(
  '[SharedLink] Get Token',
  props<{ projectUUID: string }>()
);

export const getTokenSuccess = createAction(
  '[SharedLink] Get Token Success',
  props<{ token: string }>()
);

export const getTokenFailure = createAction(
  '[SharedLink] Get Token Failure',
  props<{ error: any }>()
);

export const deleteToken = createAction(
  '[SharedLink] Delete Token',
  props<{ token: string, projectUUID: string }>()
);

export const deleteTokenSuccess = createAction(
  '[SharedLink] Delete Token Success'
);

export const deleteTokenFailure = createAction(
  '[SharedLink] Delete Token Failure',
  props<{ error: any }>()
);
